/**
 * =============================================================================
 * offcanvas-cart-swiper.js
 * =============================================================================
 * offcanvas cart swiper initialization when cart is empty
 * =============================================================================
 */

var OffcanvasCartSwiper = {

  onReady: function(){

    document.addEventListener("minicart:updated", function(event) {
      // console.log("Mini cart updated!", event.detail.cart); // Logs cart data
    }); 
  },

}

export default OffcanvasCartSwiper;